import { render, staticRenderFns } from "./PasswordResetSetPassword.vue?vue&type=template&id=f943ce22&"
import script from "./PasswordResetSetPassword.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports